import {api} from "../app/api.js";

export class AkkuService
{
  constructor()
  {
  }

  async SendQuery(query) {
    if (!this.isValid(query))
        return [];
    return api.post('Akku', 'Query', query);
  }

  isValid(query)
  {
    if (query == null) return false;
    return query.split(" ").some(w => w.length >= 2);
  }
}
